import { GET_SEARCH_DROPDOWN_INIT,RESET_SEARCH_DROPDOWN } from "redux/actionTypes/search.actionTypes";


export const getSearchDropdown = (payload) => {
  return { type: GET_SEARCH_DROPDOWN_INIT, payload };
};
export const resetSearch = () => {
  return { type: RESET_SEARCH_DROPDOWN };
};